// extracted by mini-css-extract-plugin
export var clickToAction = "clickable-module--clickToAction--e0ce7";
export var clickable = "clickable-module--clickable--b27d7";
export var decorated = "clickable-module--decorated--a2341";
export var ghost = "clickable-module--ghost--a01d6";
export var primary = "clickable-module--primary--f07b7";
export var secondary = "clickable-module--secondary--5d40b";
export var subtitle = "clickable-module--subtitle--f5565";
export var text = "clickable-module--text--f795d";
export var title = "clickable-module--title--057e5";